var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M9.358 16.717h5.339V7.283H9.358z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M9.697 12c0-1.914.911-3.619 2.33-4.717A6.14 6.14 0 0 0 8.257 6c-3.37 0-6.102 2.686-6.102 6s2.732 6 6.102 6a6.14 6.14 0 0 0 3.77-1.283A5.954 5.954 0 0 1 9.697 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M21.9 12c0 3.314-2.732 6-6.102 6a6.14 6.14 0 0 1-3.77-1.283A5.954 5.954 0 0 0 14.357 12a5.954 5.954 0 0 0-2.33-4.717A6.14 6.14 0 0 1 15.797 6c3.37 0 6.101 2.686 6.101 6M22.195 16.485v-1h-.12l-.139.687-.138-.687h-.12v1h.084v-.754l.13.65h.089l.13-.653v.757h.084zm-.762 0v-.83h.154v-.168h-.392v.168h.154v.83h.084z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcMaster);
export default __webpack_public_path__ + "static/media/cc-master.a48094b74e0de241d55ee8debff2ca95.svg";
export { ForwardRef as ReactComponent };